// Store the previous listing context for the breadcrumb script on the PDP.

const isBlogs = window.location.href.includes('blogs')
const isProduct = window.location.href.includes('products')
const isPages = window.location.href.includes('pages')
const urlTemplate = isBlogs ? 'blogs' : isPages ? 'pages' : 'collections'
const collectionHandle = document.documentElement.dataset.collectionHandle
const collectionTitle = document.documentElement.dataset.collectionTitle
const collectionUrl = document.documentElement.dataset.collectionUrl
const locale = document.documentElement.lang

if (window.location.href.includes(urlTemplate)) {
  let relativeUrl = window.location.href.split(`${urlTemplate}`)[1]

  if (isBlogs) {
    const articleParts = relativeUrl.split('/')
    if (articleParts.length > 2) {
      relativeUrl = `/${articleParts[2]}`
    }
  }

  relativeUrl = relativeUrl.split('?')[0]

  if (!isProduct) {
    const previousPageUrl =
      urlTemplate === 'collections' && collectionUrl
        ? collectionUrl
        : `/${urlTemplate}${relativeUrl}`

    localStorage.setItem('prevPage', previousPageUrl)
    localStorage.setItem('prevPageLocale', locale)

    if (urlTemplate === 'collections' && collectionTitle) {
      localStorage.setItem('prevPageHandle', collectionHandle)
      localStorage.setItem('prevPageTitle', collectionTitle)
    } else {
      localStorage.removeItem('prevPageHandle')
      localStorage.removeItem('prevPageTitle')
    }
  }
}
